module.exports = __webpack_public_path__ + "bf9071520301ea2b23f08f7ccaa005f9.pdf";